import Logo from "../../src/assets/Logo.svg";
import { Link } from "react-router-dom";
import AuthContainer from "../components/Shared/AuthContainer";
import RegisterForm from "../components/Auth/RegisterForm";
import { motion } from "framer-motion";

import { Helmet } from "react-helmet";
const Register = () => {
  return (
    <div className="min-h-screen px-4 md:py-10 pb-10 pt-5 flex justify-between xl:gap-16 gap-10">
      <Helmet>
        <link rel="canonical" href="https://www.nilewisect.com/register" />
      </Helmet>
      <motion.div
        initial={{ x: -60, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="flex flex-col w-full xl:basis-[40%] lg:basis-[45%]"
      >
        <Link
          to="/"
          className="flex items-center gap-1.5 md:justify-start justify-center md:border-b-0 border-b border-black/15 md:pb-0 pb-5"
        >
          <img src={Logo} className="md:h-auto md:w-auto w-36 h-auto" />
        </Link>
        <RegisterForm />
      </motion.div>
      <AuthContainer />
    </div>
  );
};

export default Register;
